import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hidden", "container"]

  connect() {
    this.render()
  }

  get points() {
    try {
      return JSON.parse(this.hiddenTarget.value) || []
    } catch {
      return []
    }
  }

  set points(value) {
    this.hiddenTarget.value = JSON.stringify(value)
  }

  render() {
    const pts = this.points
    this.containerTarget.innerHTML = ""

    pts.forEach((pt, idx) => {
      const row = document.createElement("div")
      row.className = "d-flex gap-2 mb-2 align-items-center"
      row.innerHTML = `
        <span class="badge text-bg-light border text-center" style="min-width: 36px;">${idx + 1}</span>
        <input type="number" step="0.1" class="form-control form-control-sm" style="flex: 1;"
               value="${pt.mac}" placeholder="%MAC" data-field="mac" data-index="${idx}">
        <input type="number" step="1" class="form-control form-control-sm" style="flex: 1;"
               value="${pt.weight}" placeholder="Weight (kg)" data-field="weight" data-index="${idx}">
        <button type="button" class="btn btn-outline-danger btn-sm px-2" data-action="envelope-editor#removePoint" data-index="${idx}" title="Remove">
          <i class="bi bi-x-lg"></i>
        </button>
      `
      row.querySelectorAll("input").forEach((input) => {
        input.addEventListener("change", (e) => this.updatePoint(e))
      })
      this.containerTarget.appendChild(row)
    })
  }

  addPoint() {
    const pts = this.points
    // Default to last point's values or empty
    const last = pts[pts.length - 1]
    pts.push({ mac: last?.mac || 0, weight: last?.weight || 0 })
    this.points = pts
    this.render()
  }

  removePoint(event) {
    const idx = parseInt(event.currentTarget.dataset.index)
    const pts = this.points
    pts.splice(idx, 1)
    this.points = pts
    this.render()
  }

  updatePoint(event) {
    const idx = parseInt(event.target.dataset.index)
    const field = event.target.dataset.field
    const pts = this.points
    pts[idx][field] = parseFloat(event.target.value) || 0
    this.points = pts
  }

  loadDefaults() {
    // Fetch defaults from YAML config via a data attribute
    const defaults = this.element.dataset.envelopeEditorDefaults
    if (defaults) {
      try {
        this.points = JSON.parse(defaults)
        this.render()
      } catch {
        // ignore
      }
    }
  }

  clear() {
    this.points = []
    this.render()
  }
}
